import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, theme } from 'antd';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          colorPrimary: '#4fc3f7',
          fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
        },
      }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>
);